export default "__VITE_ASSET__B62HX1s1__"